import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, AvatarGroup, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, ButtonGroup, Card, CardBody, CardFooter, Divider, Flex, Heading, IconButton, Image, Input, InputGroup, InputLeftElement, Select, SimpleGrid, Skeleton, SkeletonText, Stack, Text, useColorModeValue, useDisclosure, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, HStack, Tooltip, Center, Icon } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { IoAddSharp } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import ReactSelect from 'react-select';
import { FaFilePdf, FaImage } from 'react-icons/fa';
import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'
import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuItemOption,
    MenuGroup,
    MenuOptionGroup,
    MenuDivider,
} from '@chakra-ui/react'
import { AddIcon, EditIcon, ExternalLinkIcon, HamburgerIcon, RepeatIcon, SearchIcon } from '@chakra-ui/icons';
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
} from '@chakra-ui/react'
import { CiMenuKebab } from "react-icons/ci";
import { FiEdit3 } from 'react-icons/fi';
import { MdDelete, MdHistory, MdOutlineAddShoppingCart } from 'react-icons/md';
import { TbListDetails } from "react-icons/tb";
import axiosClient from '../../../axios-client';

import outOfStock from './assets/images/out-of-stock.png'
import { useStateContext } from '../../../context/ContextProvider';
import MyPagination from '../../../components/MyPagination';




function MyStock() {

    const { user, setToken, setUser, dataSubscriptionUser, currentBusiness, setCurrentBusiness } = useStateContext()
    const { t } = useTranslation();
    const navigate = useNavigate()

    const userId = user.id
    const userRole = user.role
    const userWorks_For = user.works_for

    const { isOpen, onOpen, onClose } = useDisclosure()

    // Stock Modal state
    const { isOpen: isStockModalOpen, onOpen: onStockModalOpen, onClose: onStockModalClose } = useDisclosure()
    const [selectedProductForStock, setSelectedProductForStock] = useState(null)
    const [modalStock, setModalStock] = useState([])
    const [modalStockLoading, setModalStockLoading] = useState(false)
    const [modalFilterStatus, setModalFilterStatus] = useState(null)
    const [modalFilterQuery, setModalFilterQuery] = useState('')
    const [modalFilterDate, setModalFilterDate] = useState('')
    const colorbg = useColorModeValue('white', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')

    const openStockModal = async (product) => {
        setSelectedProductForStock(product)
        setModalStock([])
        setModalFilterStatus(null)
        setModalFilterQuery('')
        setModalFilterDate('')
        onStockModalOpen()
        setModalStockLoading(true)
        try {
            await axiosClient.get(`/products/${product.id}/?business=${currentBusiness.id}`).then(res => {
                setModalStock(res.data.stock.filter(e => e.is_deleted === false))
            })
        } catch (err) {
            toast({
                description: t("Erreur lors de la récupération du stock"),
                status: 'error',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
            })
        } finally {
            setModalStockLoading(false)
        }
    }

    const descColor = useColorModeValue('gray.400', 'gray.500')
    const menuCard = useColorModeValue('white', 'gray.500')
    const menuItemDelete = useColorModeValue("red", "red.300")

    const [paginationData, setPaginationData] = useState()
    const [dataProduct, setDataProduct] = useState([])
    const [loading, setLoading] = useState(true)

    const [dataImagesProduct, setDataImagesProduct] = useState([])
    const getImagesProduct = (id) => {
        setDataImagesProduct(dataProduct.find(e => e.id === id).images)
        console.table(dataProduct.find(e => e.id === id)?.images);
        onOpen()
    }

    const toast = useToast()



    // DELETE

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [deletedId, setDeletedId] = useState()
    const [date_creation, setDate_creation] = useState()
    const [date_modification, setDate_modification] = useState()

    const onOpenAlert = (id, dateCreation, dateModification) => {
        setIsAlertOpen(true);
        setDeletedId(id)
        setDate_creation(dateCreation)
        setDate_modification(dateModification)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setDeletedId()
        setDate_creation()
        setDate_modification()
    };

    const deleteProduct = () => {
        axiosClient.patch(`/products/${deletedId}/?business=${currentBusiness.id}`, {
            is_deleted: true
        }).then(() => {
            if (
                new Date(date_creation).getTime() < new Date(dataSubscriptionUser?.subscription?.end_date).getTime() &&
                new Date(date_creation).getTime() >= new Date(dataSubscriptionUser?.subscription?.start_date).getTime()
            ) {
                axiosClient.patch(`client-subscriptions/${dataSubscriptionUser?.subscription?.id}/`, {
                    products_count: parseInt(dataSubscriptionUser?.subscription?.products_count) - 1
                });
            }
            setDataProduct(dataProduct.filter(e => e.id !== deletedId))
            onCloseAlert()
        })
    }

    // PAGINATION

    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    //GEt Data 

    const fetchData = async (pageSize, currentPage, searchTerm) => {
        try {
            setLoading(true)

            await axiosClient.get(`/products/getAllProducts/?id_user=${user.id}&page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&userRole=${user?.role}&business=${currentBusiness.id}`).then(async (res) => {
                if (res.data.length !== 0) {
                    setDataProduct(await res.data.results)
                    setPaginationData(res.data)
                    setLoading(false)
                } else {
                    setDataProduct([])
                    setPaginationData([])
                    setLoading(false)
                }

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }

                // console.log('DATA : ', res.data);
            }).catch(err => {
                setLoading(false)
                // console.log('ERROR : ', err);
            })
        } catch (error) {
            setLoading(false)
            // console.log('ERROR : ', error);
        }
    }

    useEffect(() => {
        // console.log("ID User : ", userRole === "AdminClient" ? userId : userWorks_For);
        if (user?.id) {
            fetchData(pageSize, currentPage, searchTerm)
        }
    }, [user?.id, currentPage, searchTerm, pageSize])

    // console.log('DATA setDataProduct : ', dataProduct);

    return (
        <Stack position={'relative'}>

            <Box position='fixed' bottom={5} right={5} zIndex={999}>
                <Button colorScheme='purple' variant={'solid'} onClick={() => {
                    if (dataSubscriptionUser?.message === 'Client has no active subscription') {
                        toast({
                            description: t("Pas d'abonnement actif"),
                            status: 'warning',
                            duration: 2000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                        return
                    }
                    else if (dataSubscriptionUser?.subscription?.demande) {
                        toast({
                            description: t("Votre abonnement n'est pas encore accepté"),
                            status: 'warning',
                            duration: 2000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                        return
                    }
                    else if (!dataSubscriptionUser?.subscription?.is_active) {
                        toast({
                            description: t("Votre abonnement est désactivé"),
                            status: 'warning',
                            duration: 2000,
                            isClosable: true,
                            variant: 'left-accent',
                            position: 'bottom-right'
                        })
                        return
                    }
                    else navigate('/NewStock')
                }}>
                    <IoAddSharp size={18} />
                </Button>
            </Box>

            <Flex>
                <Box w="90%" pt='12px' mb={5}>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Gestion stock")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>

                <Flex align="center" gap={5} direction="row" justify="end">
                    {
                        dataSubscriptionUser?.message === 'Client has no active subscription' ?
                            <Badge colorScheme='red'
                                rounded="xl"
                                title={t("Pas d'abonnement actif")}
                                px={2}>
                                {t("Pas d'abonnement actif")} !
                            </Badge>
                            :
                            dataSubscriptionUser?.subscription?.demande || !dataSubscriptionUser?.subscription?.is_active
                                ?
                                <>
                                    {dataSubscriptionUser?.subscription?.demande
                                        &&
                                        <Badge colorScheme='red'
                                            rounded="xl"
                                            title={t("Votre abonnement n'est pas encore accepté")}
                                            px={2}>
                                            {t("Abonnement en attente")}
                                        </Badge>}

                                    {!dataSubscriptionUser?.subscription?.demande && !dataSubscriptionUser?.subscription?.is_active
                                        &&
                                        <Badge colorScheme='red'
                                            rounded="xl"
                                            title={t("Votre abonnement est désactivé")}
                                            px={2}>
                                            {t("Abonnement désactivé")}
                                        </Badge>}
                                </>
                                :
                                <Badge colorScheme={parseInt(dataSubscriptionUser?.subscription?.products_count) === parseInt(dataSubscriptionUser?.products_limit) ? 'red' : 'green'}
                                    rounded="xl"
                                    title={parseInt(dataSubscriptionUser?.subscription?.products_count) === parseInt(dataSubscriptionUser?.products_limit) ? t('Vous avez atteint la limite du stock pour votre abonnement') : t("Nombre de stock restants")}
                                    px={2}>
                                    {dataSubscriptionUser?.subscription?.products_count} / {dataSubscriptionUser?.products_limit} {t('produits')}
                                </Badge>
                    }
                </Flex>
            </Flex>
            <Flex
                justifyContent="end"
                alignItems="center"
                direction={{ base: 'column', lg: 'row' }}
                mb={2}
            // pt={3}
            >
                {/* <Flex w={"100%"}>
                            <Select  borderRadius="5" size="md" fontSize={{ base: 13, lg: 16 }} w={{ base: '70%', lg: '50%' }} mr={5} mb={4} >
                                <option value="">{t("Tout les utilisateurs")}</option>
                                <option value="ADMIN">{t("Administrateur")}</option>
                                <option value="RESPO">{t("Responsable")}</option>
                                <option value="AGENTSUPPORT">{t("Agent de support client")} </option>
                                <option value="RESPOEVENTS">{t("Responsable des événements")}</option>
                            </Select>
                            <Select  borderRadius="5" size="md" fontSize={{ base: 13, lg: 16 }} w={{ base: '30%', lg: "20%" }} mb={4} >
                                <option value="">{t("Tout")}</option>
                                <option value="true">{t("Activé")}</option>
                                <option value="false">{t("Désactivé")}</option>
                            </Select>
                        </Flex> */}


                <InputGroup size="md" w={{ base: '100%', lg: "40%" }} borderColor={useColorModeValue('gray.400', "gray.500")}>
                    <InputLeftElement
                        pointerEvents='none'
                        children={<SearchIcon color='gray.300' />}
                    />
                    <Input

                        borderRadius="5"
                        placeholder={t("Recherche...")}
                        borderColor={useColorModeValue("gray.300", "gray.600")}
                        mb={4}
                        sx={{
                            marginLeft: 'auto',
                        }}
                        value={searchTerm}
                        onChange={(e) => {
                            setCurrentPage(0)
                            setSearchTerm(e.target.value)
                        }}
                    />  </InputGroup>

            </Flex>

            <SimpleGrid px={10} templateColumns='repeat(auto-fill,minmax(250px,1fr))' spacing={7}>
                {/* {
                    loading &&
                    <Card mt={5} rounded={"2xl"}>
                        <CardBody>
                            <Stack position={"relative"}>
                                <Skeleton height={200} borderRadius='2xl' mt={-12} />
                            </Stack>
                            <Stack alignItems='center'>
                                <SkeletonText mt='4' w={95} noOfLines={1} spacing='4' skeletonHeight='2' />
                            </Stack>
                            <Stack>
                                <SkeletonText mt='6' noOfLines={2} spacing='4' skeletonHeight='2' />
                            </Stack>

                            <Stack alignItems='center'>
                                <SkeletonText mt='6' w={95} noOfLines={1} spacing='4' skeletonHeight='2' />
                            </Stack>
                        </CardBody>
                    </Card>
                } */}

                {(!loading && dataProduct.length !== 0) &&
                    dataProduct.map((val, key) => {
                        return (
                            <Card key={key} mt={5} rounded={"2xl"}>
                                <CardBody>
                                    <Stack position={"relative"}>
                                        <Image
                                            height={"200px"}
                                            mt={-12}
                                            src={val.images[0]?.image}
                                            alt='Image'
                                            borderRadius='2xl'
                                            objectFit="cover"
                                            cursor={'pointer'}
                                            onClick={() => {
                                                // getImagesProduct(val.id)
                                                // Navigation vers Détails Produits
                                                navigate('/DetailStock', {
                                                    state: {
                                                        id: val.id
                                                    }

                                                })
                                            }}
                                        />
                                        <Menu>
                                            <MenuButton
                                                as={IconButton}
                                                aria-label='Options'
                                                icon={<CiMenuKebab size={15} />}
                                                variant='solid'
                                                position={'absolute'}
                                                rounded={'full'}
                                                top={-10}
                                                right={2}
                                                size={'sm'}
                                                colorScheme={"blue"}
                                            />
                                            <MenuList>
                                                <MenuItem icon={<TbListDetails />} onClick={() => navigate('/DetailStock', {
                                                    state: {
                                                        id: val.id
                                                    }
                                                })}>
                                                    {t("Détails")}
                                                </MenuItem>
                                                <MenuItem icon={<TbListDetails />} onClick={() => {
                                                    openStockModal(val)
                                                }}>
                                                    {t("Visualiser le stock")}
                                                </MenuItem>
                                                <MenuItem icon={<MdOutlineAddShoppingCart />} onClick={() => navigate('/UpgradeStock', {
                                                    state: {
                                                        id: val.id
                                                    }
                                                })}>
                                                    {t("Mise à niveau du stock")}
                                                </MenuItem>
                                                <MenuItem icon={<FiEdit3 />} onClick={() => navigate('/EditStock', {
                                                    state: {
                                                        id: val.id
                                                    }
                                                })}>
                                                    {t("Modifier")}
                                                </MenuItem>
                                                {/* <MenuItem icon={<MdHistory />} onClick={() => navigate('/HistoriqueStock')}>
                                                    {t("Historique")}
                                                </MenuItem> */}
                                                <MenuItem color={menuItemDelete} icon={<MdDelete color={menuItemDelete} />} onClick={() => {
                                                    onOpenAlert(val.id, val.date_creation, val.date_modification)
                                                }}>
                                                    {t("Supprimer")}
                                                </MenuItem>
                                            </MenuList>
                                        </Menu>
                                    </Stack>
                                    <Stack pt={3} align={'center'}>

                                        <Flex justify={'space-between'} align={"start"} w="100%" mb={1}>
                                            <Heading
                                                fontSize={'lg'}
                                                fontWeight="700"
                                                noOfLines={1}
                                                title={val.title}
                                            >
                                                {val.title}
                                            </Heading>
                                            <Badge
                                                px={2}
                                                py={0.5}
                                                rounded="md"
                                                variant="outline"
                                                colorScheme="gray"
                                                fontSize="10px"
                                                opacity={0.8}
                                            >
                                                {val.code}
                                            </Badge>
                                        </Flex>
                                        <Text lineHeight={5} textAlign={'justify'} color={descColor}>
                                            {val.description}
                                        </Text>
                                        <Flex direction={'row'} align={'center'} justify={'space-between'} w="100%" pt={2}>
                                            <Text fontWeight={"medium"} fontSize={'sm'} color={descColor}>
                                                {t('Stock disponible')}
                                            </Text>
                                            {val.stock_disponible > 0 ? (
                                                <Badge
                                                    colorScheme='purple'
                                                    variant='subtle'
                                                    px={3}
                                                    py={0.5}
                                                    rounded="full"
                                                    fontSize="0.8em"
                                                >
                                                    {val.stock_disponible} {t('unités')}
                                                </Badge>
                                            ) : (
                                                <Badge
                                                    colorScheme='red'
                                                    variant='solid'
                                                    px={3}
                                                    py={0.5}
                                                    rounded="full"
                                                    fontSize="0.7em"
                                                    textTransform="uppercase"
                                                >
                                                    {t('Épuisé')}
                                                </Badge>
                                            )}
                                        </Flex>
                                    </Stack>
                                </CardBody>
                            </Card>
                        )
                    })
                }
            </SimpleGrid>

            {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
            {(!loading && dataProduct.length !== 0) &&
                <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                    <Box flex="1">
                        <MyPagination
                            paginationData={paginationData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            PAGE_SIZE={pageSize}
                        />
                    </Box>

                    <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange} marginRight={{ base: 0, lg: 20 }}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </Select>
                </Flex>
            }
            {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

            {
                (!loading && dataProduct.length === 0) &&
                <Flex flexDirection="column" alignItems='center' gap={2}>
                    <Image src={outOfStock} h={200} w={200} opacity={.5} />
                    <Text color='gray.500'>{t("Aucune donnée n'a été trouvée.")}</Text>
                </Flex>
            }


            <Drawer placement='bottom' onClose={() => {
                onClose()
                setDataImagesProduct([])
            }} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent
                    background={"#ffffff42"}
                    backdropFilter='auto' backdropBlur='8px'>
                    <DrawerBody>
                        <Flex gap={5} justify={{ base: 'none', md: 'center' }}>
                            {
                                dataImagesProduct.map((val, key) => {
                                    return (
                                        <Avatar key={key} h={150} w={150} borderRadius={'xl'} name='image' src={val.image} />
                                    )
                                })
                            }
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>



            {/* Alert to Delete Product */}

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={deleteProduct} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            {/* Modal to visualize product stock */}
            <Modal size="6xl" closeOnOverlayClick={false} isOpen={isStockModalOpen} onClose={onStockModalClose}>
                <ModalOverlay />
                <ModalContent bg={useColorModeValue('white', '#212835')} color={txtcolor}>
                    <ModalHeader fontSize="xl" borderBottomWidth="1px" borderColor={useColorModeValue('gray.200', 'gray.700')}>
                        {t("Stock de")} : <Text as="span" fontWeight="bold" color="purple.500">{selectedProductForStock?.title}</Text>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody py={6}>
                        {/* Filters Section */}
                        <Flex direction={{ base: 'column', md: 'row' }} gap={4} mb={6} align="center">
                            <Box w={{ base: '100%', md: '30%' }}>
                                <ReactSelect
                                    isClearable
                                    options={[
                                        { value: 'Disponible', label: t('Disponible') },
                                        { value: 'Épuisé', label: t('Épuisé') },
                                        { value: 'En transit', label: t('En transit') },
                                        { value: 'Endommagé', label: t('Endommagé') }
                                    ]}
                                    value={modalFilterStatus}
                                    onChange={setModalFilterStatus}
                                    placeholder={t('Filtrer par statut')}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: 'transparent',
                                            borderColor: 'gray.200'
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            textAlign: 'left',
                                            backgroundColor: colorbg,
                                            cursor: "pointer",
                                            zIndex: 9999
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            color: txtcolor,
                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                            '&:hover': {
                                                backgroundColor: colorbghover,
                                            },
                                            cursor: "pointer"
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: txtcolor,
                                        })
                                    }}
                                />
                            </Box>
                            <Box w={{ base: '100%', md: '45%' }}>
                                <Input
                                    placeholder={t("Recherche par couleur, taille, quantité, prix, poids, source, service...")}
                                    value={modalFilterQuery}
                                    onChange={(e) => setModalFilterQuery(e.target.value)}
                                    size="md"
                                />
                            </Box>
                            <Box w={{ base: '100%', md: '25%' }}>
                                <Input
                                    type="date"
                                    value={modalFilterDate}
                                    onChange={(e) => setModalFilterDate(e.target.value)}
                                    size="md"
                                />
                            </Box>
                        </Flex>

                        {modalStockLoading ? (
                            <Flex justify="center" align="center" py={10}>
                                <SkeletonText noOfLines={4} spacing="4" w="100%" />
                            </Flex>
                        ) : modalStock.length !== 0 ? (
                            <TableContainer overflowY="auto" maxH={400}>
                                <Table variant="simple">
                                    <Thead>
                                        <Tr>
                                            <Th>{t("Couleur")}</Th>
                                            <Th>{t("Taille")}</Th>
                                            <Th>{t("Quantité")}</Th>
                                            <Th>{t("Statut")}</Th>
                                            <Th>{t("Prix d'achat")}</Th>
                                            <Th>{t("Poids")}</Th>
                                            <Th>{t("Source")}</Th>
                                            <Th>{t("Entrepôt / Service")}</Th>
                                            <Th>{t("Reçu")}</Th>
                                            <Th>{t("Date d'achat")}</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {(() => {
                                            const filteredStock = modalStock.filter(item => {
                                                if (modalFilterStatus) {
                                                    if ((item.status || 'Disponible') !== modalFilterStatus.value) return false;
                                                }
                                                if (modalFilterDate) {
                                                    const itemDate = item.purchase_date || item.date_creation?.split('T')[0];
                                                    if (itemDate !== modalFilterDate) return false;
                                                }
                                                if (modalFilterQuery.trim() !== '') {
                                                    const query = modalFilterQuery.toLowerCase();
                                                    const color = (item.color || '').toLowerCase();
                                                    const size = (item.size || '').toLowerCase();
                                                    const quantity = String(item.quantity || '').toLowerCase();
                                                    const price = String(item.purchase_price || '').toLowerCase();
                                                    const weight = String(item.stock_weight || '').toLowerCase();
                                                    const source = (item.source || '').toLowerCase();
                                                    const warehouse = (item.warehouse || '').toLowerCase();

                                                    const match = color.includes(query) ||
                                                                  size.includes(query) ||
                                                                  quantity.includes(query) ||
                                                                  price.includes(query) ||
                                                                  weight.includes(query) ||
                                                                  source.includes(query) ||
                                                                  warehouse.includes(query);
                                                    if (!match) return false;
                                                }
                                                return true;
                                            });

                                            if (filteredStock.length === 0) {
                                                return (
                                                    <Tr>
                                                        <Td colSpan={10} textAlign="center" py={4} color="gray.500">
                                                            {t("Aucun stock trouvé pour ces critères.")}
                                                        </Td>
                                                    </Tr>
                                                )
                                            }

                                            return filteredStock.map((val, key) => {
                                                return (
                                                    <Tr key={key}>
                                                        <Td>{val.color ? val.color : '-'}</Td>
                                                        <Td>{val.size ? val.size : '-'}</Td>
                                                        <Td>{val.quantity}</Td>
                                                        <Td>
                                                            <Badge colorScheme={
                                                                val.status === 'Disponible' ? 'green' :
                                                                val.status === 'Épuisé' ? 'red' :
                                                                val.status === 'En transit' ? 'orange' :
                                                                val.status === 'Endommagé' ? 'yellow' : 'gray'
                                                            }>
                                                                {t(val.status || 'Disponible')}
                                                            </Badge>
                                                        </Td>
                                                        <Td>
                                                            <Flex gap={1}>
                                                                <Text fontWeight="semibold">{val.purchase_price}</Text> <Text h="100%" fontSize={12}>{currentBusiness?.currency}</Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>{val.stock_weight ? `${val.stock_weight} ${val.weight_unit || 'kg'}` : '-'}</Td>
                                                        <Td>{val.source ? val.source : '-'}</Td>
                                                        <Td>{val.warehouse ? val.warehouse : '-'}</Td>
                                                        <Td>
                                                            {((val.receipts && val.receipts.length > 0) || val.recu) ? (
                                                                <HStack spacing={1}>
                                                                    {[...(val.receipts || []), ...(val.recu ? [{file: val.recu, isLegacy: true}] : [])].map((r, i) => {
                                                                        const isPdf = r.file?.toLowerCase().endsWith('.pdf');
                                                                        return (
                                                                            <Tooltip key={i} label={`${t("Reçu")} #${i + 1}${r.isLegacy ? ' (Ancien)' : ''}`}>
                                                                                <a href={r.file} target="_blank" rel="noreferrer">
                                                                                    <Center
                                                                                        w="28px"
                                                                                        h="28px"
                                                                                        bg={isPdf ? "red.50" : "blue.50"}
                                                                                        color={isPdf ? "red.500" : "blue.500"}
                                                                                        rounded="lg"
                                                                                        transition="all 0.2s"
                                                                                        _hover={{ transform: 'translateY(-2px)', shadow: 'sm', bg: isPdf ? "red.100" : "blue.100" }}
                                                                                        border="1px solid"
                                                                                        borderColor={isPdf ? "red.200" : "blue.200"}
                                                                                    >
                                                                                        <Icon as={isPdf ? FaFilePdf : FaImage} fontSize="12px" />
                                                                                    </Center>
                                                                                </a>
                                                                            </Tooltip>
                                                                        )
                                                                    })}
                                                                </HStack>
                                                            ) : (
                                                                <Text fontSize="xs" color="gray.400">-</Text>
                                                            )}
                                                        </Td>
                                                        <Td>{val.purchase_date ? new Date(val.purchase_date).toLocaleDateString(t('fr-FR')) : new Date(val.date_creation).toLocaleDateString(t('fr-FR'))}</Td>
                                                    </Tr>
                                                )
                                            });
                                        })()}
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Text fontSize="lg" color="red.400" fontWeight="semibold" textAlign="center" py={10}>
                                {t("Votre stock est actuellement vide.")}
                            </Text>
                        )}
                    </ModalBody>
                    <ModalFooter borderTopWidth="1px" borderColor={useColorModeValue('gray.200', 'gray.700')}>
                        <Button onClick={onStockModalClose}>{t("Fermer")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

        </Stack>
    )
}

export default MyStock